import { render, staticRenderFns } from "./PWmatGetUUID.vue?vue&type=template&id=3799fb31&scoped=true&"
import script from "./PWmatGetUUID.vue?vue&type=script&lang=js&"
export * from "./PWmatGetUUID.vue?vue&type=script&lang=js&"
import style0 from "./PWmatGetUUID.vue?vue&type=style&index=0&id=3799fb31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799fb31",
  null
  
)

component.options.__file = "PWmatGetUUID.vue"
export default component.exports